import { render, staticRenderFns } from "./vue-particles.vue?vue&type=template&id=5ededfff&"
import script from "./vue-particles.vue?vue&type=script&lang=js&"
export * from "./vue-particles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports